module.exports = __webpack_public_path__ + "img/DAVIVIENDA II.36968cec.png";